package org.multiplatform.kotfolio.pages.kotlin.new_feature

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kotlin/new_feature/2.5.0.beta1")
@Composable
fun NewFeature_2_5_0_beta_1_Page() {
    BlogLayout(
        PageProperties(
            "Kotlin 2.5.0 Beta1",
            ""
        ),
        BlogProperties("Kotlin New Feature", "2.5.0 Beta1")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Name-based destructuring stable",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    val (x, y) = point        // old: based on position
                    (val x, val y) = point    // new: based on names
                    """.trimIndent()
            )

            SpanText(
                text = "Boolean [onTrue(), onFalse(), ifOrNull()]",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import android.util.Log 
                    import androidx.work.WorkManager
                    
                    private const val TAG = "BackgroundSync"
                    
                    @OptIn (ExperimentalStdlibApi: :class)
                    fun isSchedulerReady): Boolean =
                        WorkManager.isInitialized()
                            .onTrue {
                                Log.d(TAG, "Background scheduler is ready")
                            }
                            .onFalse {
                                Log.w(TAG, "Background scheduler is not initialized")
                        }
                     
                     @OptIn (ExperimentalStdlibApi: :class)
                     fun authorizationHeader(accessToken: String): String? =
                        ifOrNull(accessToken.isNotBlank()) {
                            "Bearer "
                        }       
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @OptIn(ExperimentalStdlibApi::class)
                    fun main() {
                        val tags = mutableSetOf("kotlin", "jvm")

                        val added = tags.add("wasm").onTrue {
                            println("Tag added")
                        }

                        val message = ifOrNull("wasm" in tags) {
                            "Wasm tag is available"
                        }
                        println(message) // Wasm tag is available
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Companion extensions and companion blocks (experimental)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    kotlin {
                        compilerOptions {
                            freeCompilerArgs.add("-Xcompanion-blocks-and-extensions")
                        }
                    }
                    
                    // Companion extension
                    companion val Vector.UnitX get() = Vector(1.0, 0.0)

                    data class Vector(val x: Double, val y: Double) {
                        companion {
                            // Companion block
                            val Zero: Vector get() = Vector(0.0, 0.0)
                        }
                    }

                    fun main() {
                        println(Vector.UnitX) // Vector(x=1.0, y=0.0)
                        println(Vector.Zero)  // Vector(x=0.0, y=0.0)
                    }
                    """.trimIndent()
            )
        }
    }
}